import React, { useContext } from "react"
import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import useScreenType from "components/ProjectNonSpecificComponents/Hooks/useScreenType"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import { UserContext } from "components/ProjectSpecificComponents/Contexts/UserContext"
import UserIcon from "../../Global/atoms/Icons/UserIcon"

export const UserInfo = () => {
	const formStore = useFormStore()
	const { user } = useContext(UserContext)
    const { isMobile } = useScreenType()
    
	return (<>
        {!isMobile ? 
            <HyperDiv
			style={{
                color: formStore.settingsData.personalize.colorHeaderText ?? "var(--blue)",
				fontSize: "14px",
				fontWeight: 600,
			}}
            >
			{user?.fullName}
            </HyperDiv> :
            <HyperDiv>
                <UserIcon />
            </HyperDiv>
        }
        </>
	)
}
